import { Alert, Link } from "@heroui/react";

export type StorageQuotaExhaustedAlertProps = {
  className?: string;
  /** 前往扩容/存储管理的路径，各端路由不同 */
  storageManageHref: string;
};

export default function StorageQuotaExhaustedAlert({
  className,
  storageManageHref,
}: StorageQuotaExhaustedAlertProps) {
  return (
    <Alert className={className ?? "rounded-md"} status="accent">
      <Alert.Indicator />
      <Alert.Content>
        <Alert.Title>容量已用尽</Alert.Title>
        <Alert.Description>
          您的容量已用尽，您将无法继续上传文件，下载和发货将不受影响，您可前往
          <Link href={storageManageHref}>存储管理</Link>
          购买扩容或删除文件以解除该限制。
        </Alert.Description>
      </Alert.Content>
    </Alert>
  );
}
